import type { ComponentProps } from 'react';

// Shared arrow visual for the Base UI overlay primitives (Tooltip, Popover).
//
// Each primitive's Base UI `<X.Arrow>` differs — `Tooltip.Arrow` and `Popover.Arrow`
// each bind to their own positioning context — so the namespace-bound wrapper stays
// in each primitive. Only the parts that are genuinely identical live here: the
// triangle shape and the per-`data-side` placement classes.

// Per-side placement: Base UI flips the arrow to the popup edge facing the anchor and
// sets `data-side`; these rotate the upward-pointing triangle to match and nudge it to
// sit flush against the popup border.
export const overlayArrowSideClasses = [
  'data-[side=bottom]:-top-2.25 data-[side=bottom]:rotate-180',
  'data-[side=left]:-right-3.5 data-[side=left]:-rotate-90',
  'data-[side=right]:-left-3.5 data-[side=right]:rotate-90',
  'data-[side=top]:-bottom-2.25',
];

// The borderless white triangle that matches the popup surface (`fill-background`),
// at the 20×10 size the overlays have always used.
export const OverlayArrowSvg = (props: ComponentProps<'svg'>) => (
  <svg width="20" height="10" viewBox="0 0 20 10" className="fill-background" {...props}>
    <path d="M0 0 L10 9 L20 0 Z" />
  </svg>
);
